import React from 'react';
import { Check, Award, Users, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { brandInfo } from '../data/mockData';

const AboutSection = ({ onOpenBuilder }) => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.pexels.com/photos/1064766/pexels-photo-1064766.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt="Islamic Architecture"
                className="w-full h-48 object-cover rounded-lg shadow-lg"
              />
              <img
                src="https://images.pexels.com/photos/2406731/pexels-photo-2406731.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt="Mosque"
                className="w-full h-48 object-cover rounded-lg shadow-lg mt-8"
              />
            </div>
            {/* Stats Card */}
            <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-white shadow-xl rounded-lg p-6 grid grid-cols-3 gap-6">
              <div className="text-center">
                <Award className="w-8 h-8 text-[#d4af37] mx-auto" />
                <p className="text-2xl font-bold text-gray-900">15+</p>
                <p className="text-xs text-gray-500">Years Experience</p>
              </div>
              <div className="text-center border-x border-gray-200">
                <Users className="w-8 h-8 text-[#d4af37] mx-auto" />
                <p className="text-2xl font-bold text-gray-900">10K+</p>
                <p className="text-xs text-gray-500">Pilgrims Served</p>
              </div>
              <div className="text-center">
                <Clock className="w-8 h-8 text-[#d4af37] mx-auto" />
                <p className="text-2xl font-bold text-gray-900">24/7</p>
                <p className="text-xs text-gray-500">Support</p>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div>
            <span className="text-[#d4af37] font-medium tracking-wider">ABOUT US</span>
            <h2 
              className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              The Smart Way to Build Your Umrah
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              <strong>ZamZam Umrah</strong> offers the cheapest Umrah packages online. We focus 100% on what matters 
              for your pilgrimage: premium hotels near the Holy Mosques, comfortable ground transport, 
              visa services, and guided Ziyarat tours.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Our innovative package builder lets you customize every aspect of your Umrah journey. 
              Choose your preferred hotels in Makkah and Madinah, select your room type, add transport 
              options, and get instant pricing - all in one place.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 bg-[#d4af37] rounded-full flex items-center justify-center">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <span className="text-gray-700">ATOL Protected Travel Agency</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 bg-[#d4af37] rounded-full flex items-center justify-center">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <span className="text-gray-700">Umrah-Only Specialists</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 bg-[#d4af37] rounded-full flex items-center justify-center">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <span className="text-gray-700">Flexible Package Builder</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-6 h-6 bg-[#d4af37] rounded-full flex items-center justify-center">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <span className="text-gray-700">24/7 Pilgrim Support</span>
              </li>
            </ul>

            <div className="flex gap-4">
              <Button
                onClick={onOpenBuilder}
                className="bg-[#d4af37] text-black hover:bg-[#c4a030] font-bold px-6"
              >
                START BUILDING
              </Button>
              <Button
                variant="ghost"
                className="text-gray-700 hover:bg-gray-200 font-bold"
              >
                CONTACT US
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
